module.exports = __webpack_public_path__ + "static/media/logo-stopka.aba43da8.png";